// extracted by mini-css-extract-plugin
export default {"back":"BackButton_back__SXfLx","back__img":"BackButton_back__img__afdtT"};